import type {
  GetCustomerAccountAddressesResponse,
  GetCustomerAccountResponse,
} from '@djust-b2b/djust-front-sdk';
import type { CustomerUser } from '@djust-b2b/djust-front-sdk/lib/interfaces/models/customer-user.js';
import { defineStore } from 'pinia';

interface State {
  isAdminAuthenticated: boolean;
  user: null | undefined | CustomerUser;
  currency: null | string;
}

type BasicAccount = Pick<GetCustomerAccountResponse, 'id' | 'name' | 'externalId'>;

export const useUserAdminStore = defineStore('userAdmin', {
  state: (): State => ({
    isAdminAuthenticated: false,
    user: null,
    currency: null as null | string,
  }),

  actions: {
    loginAuthenticatedUser(authenticatedUser: {
      user: CustomerUser;
      accounts: BasicAccount[];
      account: BasicAccount;
      currency: string;
    }) {
      this.isAdminAuthenticated = true;
      this.user = authenticatedUser.user;

      this.currency = authenticatedUser.currency;

    },

    login(authenticatedUser: {
      user: CustomerUser;
      accounts: BasicAccount[];
      account: GetCustomerAccountResponse;
      currency: string;
    }) {
      this.loginAuthenticatedUser(authenticatedUser);
    },
    logout() {
      this.isAdminAuthenticated = false;
      this.user = null;
      this.currency = null;
    },
  },
});
